/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type FavoritesItem_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly isAuctionEnabled: boolean | null;
    readonly " $refType": "FavoritesItem_item";
};
export type FavoritesItem_item$data = FavoritesItem_item;
export type FavoritesItem_item$key = {
    readonly " $data"?: FavoritesItem_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"FavoritesItem_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavoritesItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'a51df215f7f70c956ed7c12f0771150f';
export default node;
